import toSerializableError from '../shared/toSerializableError';

function getRTQueryResultFromPromise<T>(promise: Promise<T>) {
  return promise
    .then((data) => ({ data }))
    .catch((error) => ({ error: toSerializableError(error) }));
}

export default getRTQueryResultFromPromise;
